export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading text-primary-400">
              爆料吃瓜
            </span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              国内领先的吃瓜网站与爆料网站导航聚合平台，一站式在线吃瓜导航。实时追踪微博、豆瓣、贴吧、小红书等全平台热门八卦，聚合最新瓜料资源，让你快人一步掌握全网吃瓜动态。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              快速导航
            </h3>
            <div className="flex flex-col gap-2.5">
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                热门话题
              </a>
              <a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                最新爆料
              </a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                吃瓜榜单
              </a>
              <a href="#features" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                特色优势
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              吃瓜分类
            </h3>
            <div className="flex flex-col gap-2.5">
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                娱乐圈八卦
              </a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                网红爆料
              </a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                综艺吃瓜
              </a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                行业深扒
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              合作伙伴
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              我们与多家优质吃瓜资源站点保持紧密合作，持续为用户提供最全面的在线吃瓜导航服务。合作伙伴信息持续更新中。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 爆料吃瓜 | 吃瓜网站爆料网站在线吃瓜导航 —— 聚合热门八卦、实时瓜料与最新吃瓜资源
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>理性吃瓜</span>
            <span className="w-px h-3 bg-foreground-700"></span>
            <span>文明讨论</span>
            <span className="w-px h-3 bg-foreground-700"></span>
            <span>拒绝谣言</span>
          </div>
        </div>
      </div>
    </footer>
  );
}